// Google Translate (and some other DOM-mutating extensions) replace text nodes
// with their own <font> wrappers. React still holds references to the original
// nodes, so when it later reconciles it calls removeChild / insertBefore on
// nodes whose parent has changed, throwing
//   NotFoundError: Failed to execute 'removeChild' on 'Node'
// which crashes the whole app.
//
// This patches the two DOM methods React uses so that, when the node is no
// longer under the expected parent, we no-op instead of throwing. This is the
// workaround recommended in the React issue (facebook/react#11538) and lets the
// page keep working while translated.
export function installGoogleTranslateFix() {
  if (typeof Node !== 'function' || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
